import { DyInputTextArea } from "../../widgets/dyInputTextArea";
import { ICellEditorComp, ICellEditorParams } from "../../interfaces/iCellEditor";
import { PopupComponent } from "../../widgets/popupComponent";
import { RefSelector } from "../../widgets/componentAnnotations";
import { exists } from "../../utils/generic";
import { KeyCode } from '../../constants/keyCode';

export interface ILargeTextEditorParams extends ICellEditorParams {
  maxLength: number;
  rows: number;
  cols: number;
}

export class LargeTextCellEditor extends PopupComponent implements ICellEditorComp {
  private static TEMPLATE = /* html */
    `<div class="dy-large-text" tabindex="0">
            <dy-input-text-area ref="eTextArea" class="dy-large-text-input"></dy-input-text-area>
        </div>`;

  private params: ILargeTextEditorParams;
  @RefSelector("eTextArea") private eTextArea: DyInputTextArea;
  private focusAfterAttached: boolean;

  constructor() {
    super(LargeTextCellEditor.TEMPLATE);
  }

  public init(params: ILargeTextEditorParams): void {
    this.params = params;

    this.focusAfterAttached = params.cellStartedEdit;

    this.eTextArea
      .setMaxLength(params.maxLength || 200)
      .setCols(params.cols || 60)
      .setRows(params.rows || 10);

    if (exists(params.value)) {
      this.eTextArea.setValue(params.value.toString(), true);
    }

    this.addGuiEventListener('keydown', this.onKeyDown.bind(this));
  }

  private onKeyDown(event: KeyboardEvent): void {
    const key = event.which || event.keyCode;

    if (key === KeyCode.LEFT ||
      key === KeyCode.UP ||
      key === KeyCode.RIGHT ||
      key === KeyCode.DOWN ||
      (event.shiftKey && key === KeyCode.ENTER)) { // shift+enter allows for newlines
      event.stopPropagation();
    }
  }

  public afterGuiAttached(): void {
    const translate = this.gridOptionsWrapper.getLocaleTextFunc();

    this.eTextArea.setInputAriaLabel(translate('ariaInputEditor', 'Input Editor'));

    if (this.focusAfterAttached) {
      this.eTextArea.getFocusableElement().focus();
    }
  }

  public getValue(): any {
    return this.params.parseValue(this.eTextArea.getValue());
  }
}
